module.exports = __webpack_public_path__ + "00130cd6cb0c744f66ab66b5b44b4938.fbx";